import React from "react"
import AuthenticationStore from "../../stores/AuthenticationStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import ExpandedLeftNav from "./ExpandedLeftNav"
import CollapsedLeftNav from "./CollapsedLeftNav"
import ScheduleLeftNav from "../../pages/schedules/ScheduleLeftNav"
import HierarchyLeftNav from "../../pages/hierarchy/HierarchyLeftNav"
import AccountLeftNav from "../../pages/account/AccountLeftNav"
import autobind from "class-autobind"
import * as userActions from "../../actions/UserActions"
import * as permissionHelper from "../../helpers/permissionHelper"
import { ELoggedInUserType } from "../../models"
import { ListItem, MenuItem } from "material-ui"
import strings from "../../localization/strings"
import { browserHistory } from "react-router"

interface IProps {
	selectedItem?: string
	selectedHierarchy?: boolean
	page: string
	loggedInUserType: ELoggedInUserType
	params: any
	onLogoutClick(): void
}
interface IState {
	expand: string
	open: boolean
	showTimecards: boolean
	showEquipment: boolean
	showEmployees: boolean
	showRecords: boolean
	showTopLeveDevices: boolean
	isAdmin: boolean
	cookieAccountId: string
	dateFilter: string
	accountId: string
	accountSelectedItem: string
	hierarchySelectedItem: string
	hierarchySubItems: string[],
	showPayroll: boolean
	showLeaveTracking: boolean
	isRootLevelHierarchy: boolean
	showSchedule: boolean
	showClients: boolean
	showJobs: boolean
	showHierarchy: boolean
	showGigPool: boolean
}

export default class LeftNav extends React.PureComponent<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			expand: AppStateStore.getExpandNav(),
			open: false,
			showTimecards: AccountStore.getTimecardEnabled() &&
				permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards),
			showEquipment: AccountStore.getEquipmentEnabled() &&
				permissionHelper.hasPermission(AuthenticationStore.Permissions.Equipment.ViewEquipment),
			showEmployees: permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees),
			showRecords: permissionHelper.hasPermission(AuthenticationStore.Permissions.PunchRecords.ViewRecords),
			showTopLeveDevices: permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewAllDevices),
			isAdmin: permissionHelper.isAccountAdmin(),
			cookieAccountId: AuthenticationStore.getCookieAccountId(),
			dateFilter: this.props.params ? this.props.params.filter : "today",
			accountId: this.props.params ? this.props.params.accountId : "",
			accountSelectedItem: this.props.params ? this.props.params.subpage : "Billing",
			hierarchySelectedItem: this.props.params ? this.props.params.subpage : "",
			hierarchySubItems: AppStateStore.getHierarchyNavItems(),
			showPayroll:
				(
					(AccountStore.getPayrollEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll)) ||
					(AccountStore.getPayrollEnabled() && AccountStore.getExpensesEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense))
				) ||
				AccountStore.getJobsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayrollByJob),
			showLeaveTracking:
				(!AccountStore.getHidePaywall() && !AccountStore.getAccrualsTimeoffEnabled()) ||
				(AccountStore.getAccrualsTimeoffEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.ViewLeaveTracking)),
			isRootLevelHierarchy: false,
			showSchedule:
				(!AccountStore.getHidePaywall() && !AccountStore.getScheduleEnabled()) ||
				(AccountStore.getScheduleEnabled() &&
					(
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule) ||
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewSchedule)
					)
				),
			showClients: AccountStore.getClientsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Clients.ViewClients),
			showJobs: AccountStore.getJobsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Jobs.ViewJobs),
			showHierarchy: permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewHierarchyTab),
			showGigPool: AccountStore.getHREnabled(),
		}
		autobind(this)
	}

	componentDidMount() {
		AppStateStore.on("change", this.changeEvent)
		AuthenticationStore.on("change", this.changeEvent)
		AccountStore.on("account_change", this.changeEvent)
		HierarchySettingsStore.on("change", this.changeEvent)
	}

	componentWillUnmount() {
		AppStateStore.removeListener("change", this.changeEvent)
		AuthenticationStore.removeListener("change", this.changeEvent)
		AccountStore.removeListener("account_change", this.changeEvent)
		HierarchySettingsStore.removeListener("change", this.changeEvent)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			dateFilter: nextProps.params ? nextProps.params.filter : "today",
			accountId: nextProps.params ? nextProps.params.accountId : "",
			accountSelectedItem: nextProps.params ? nextProps.params.subpage : "Billing",
			hierarchySelectedItem: nextProps.params ? nextProps.params.subpage : ""
		})
	}

	changeEvent() {
		this.setState({
			expand: AppStateStore.getExpandNav(),
			cookieAccountId: AuthenticationStore.getCookieAccountId(),
			showTimecards: AccountStore.getTimecardEnabled() &&
				permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards),
			showEquipment: AccountStore.getEquipmentEnabled() &&
				permissionHelper.hasPermission(AuthenticationStore.Permissions.Equipment.ViewEquipment),
			showEmployees: permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees),
			showRecords: permissionHelper.hasPermission(AuthenticationStore.Permissions.PunchRecords.ViewRecords),
			showTopLeveDevices: permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewAllDevices),
			isAdmin: permissionHelper.isAccountAdmin(),
			isRootLevelHierarchy: HierarchySettingsStore.getLevelDefinition() ? false : true,
			hierarchySubItems: AppStateStore.getHierarchyNavItems(),
			showPayroll:
				(
					(AccountStore.getPayrollEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll)) ||
					(AccountStore.getPayrollEnabled() && AccountStore.getExpensesEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense))
				) ||
				AccountStore.getJobsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayrollByJob),
			showLeaveTracking:
				(!AccountStore.getHidePaywall() && !AccountStore.getAccrualsTimeoffEnabled()) ||
				(AccountStore.getAccrualsTimeoffEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.ViewLeaveTracking)),
			showSchedule:
				(!AccountStore.getHidePaywall() && !AccountStore.getScheduleEnabled()) ||
				(
					AccountStore.getScheduleEnabled() &&
					(
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule) ||
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewSchedule)
					)
				),
			showClients: AccountStore.getClientsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Clients.ViewClients),
			showJobs: AccountStore.getJobsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Jobs.ViewJobs),
			showHierarchy: permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewHierarchyTab)
		})
	}

	onProfileClick() {
		userActions.openUserProfileDialog()
	}

	getExpandedLeftNavUserNestedItems() {
		const isFinddMode = AppStateStore.isFindd()
		const loggedInUserType = this.props.loggedInUserType
		const profileTextStyle = { color: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor, textDecoration: "none" }
		const onLogoutClick = this.props.onLogoutClick

		const returnVal =
			loggedInUserType === ELoggedInUserType.AccountAdmin ||
				loggedInUserType === ELoggedInUserType.AccountUser ||
				(loggedInUserType === ELoggedInUserType.EsAccUser && !permissionHelper.loggedInUserHasSpecificPermission(AuthenticationStore.SpecialPermission.SelfService)) ?
				[
					<ListItem key={1} primaryText={strings.Profile} onClick={this.onProfileClick} style={profileTextStyle} />,
					<ListItem key={2} primaryText={strings.Notification_Settings} onClick={() => browserHistory.push("/notification_settings")} style={profileTextStyle} />,
					<ListItem key={3} primaryText={strings.Logout} onClick={onLogoutClick} style={profileTextStyle} />,
				] :
				loggedInUserType === ELoggedInUserType.EsAccUser && permissionHelper.loggedInUserHasSpecificPermission(AuthenticationStore.SpecialPermission.SelfService) ?
					[
						<ListItem key={1} primaryText={strings.Profile} onClick={this.onProfileClick} style={profileTextStyle} />,
						<ListItem key={2} primaryText={strings.Notification_Settings} onClick={() => browserHistory.push("/notification_settings")} style={profileTextStyle} />,
						<ListItem key={3} primaryText={strings.Self_Service} onClick={() => browserHistory.push("/es/timecards")} style={profileTextStyle} />,
						<ListItem key={4} primaryText={strings.Logout} onClick={onLogoutClick} style={profileTextStyle} />
					] :
					AccountStore.getScheduleEnabled() ?
						[
							<ListItem key={1} primaryText={strings.Notification_Settings} onClick={() => browserHistory.push("/notification_settings")} style={profileTextStyle} />,
							<ListItem key={2} primaryText={strings.Self_Service} onClick={() => browserHistory.push("/es/timecards")} style={profileTextStyle} />,
							<ListItem key={5} primaryText={strings.Logout} onClick={onLogoutClick} style={profileTextStyle} />
						] :
						[
							<ListItem key={1} primaryText={strings.Self_Service} onClick={() => browserHistory.push("/es/timecards")} style={profileTextStyle} />,
							<ListItem key={2} primaryText={strings.Logout} onClick={onLogoutClick} style={profileTextStyle} />
						]

		if (AccountStore.getEnableWorkflows()) {
			returnVal.splice(returnVal.length - 1, 0, <ListItem key={returnVal.length + 1} primaryText={strings.Training} onClick={() => browserHistory.push("/workflows")} style={profileTextStyle} />)
		}

		return returnVal
	}

	getCollapsedLeftNavUserNestedItems() {
		const collapsedStyle = {
			backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor,
			color: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor,
			marginTop: -7
		}
		const collapsedStyleLast = {
			backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor,
			color: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor,
			marginTop: -8,
			marginBottom: -9
		}

		let returnVal =
			this.props.loggedInUserType === ELoggedInUserType.AccountAdmin ||
				this.props.loggedInUserType === ELoggedInUserType.AccountUser ||
				(this.props.loggedInUserType === ELoggedInUserType.EsAccUser && !permissionHelper.loggedInUserHasSpecificPermission(AuthenticationStore.SpecialPermission.SelfService)) ?
				[
					<div className="menu-item-wrapper">
						<MenuItem key={"collapsedStyle"} style={collapsedStyle} onClick={this.onProfileClick} primaryText={strings.Profile} />
					</div>,
					<div className="menu-item-wrapper">
						<MenuItem key={"collapsedStyleMiddel"} style={collapsedStyle} onClick={() => browserHistory.push("/notification_settings")} primaryText={strings.Notification_Settings} />
					</div>,
					<div className="menu-item-wrapper">
						<MenuItem key={"collapsedStyleLast"} style={collapsedStyleLast} onClick={this.props.onLogoutClick} primaryText={strings.Logout} />
					</div>
				] :
				this.props.loggedInUserType === ELoggedInUserType.EsAccUser && permissionHelper.loggedInUserHasSpecificPermission(AuthenticationStore.SpecialPermission.SelfService) ?
					[
						<div className="menu-item-wrapper">
							<MenuItem key={"collapsedStyle"} style={collapsedStyle} onClick={this.onProfileClick} primaryText={strings.Profile} />
						</div>,
						<div className="menu-item-wrapper">
							<MenuItem key={"collapsedStyleMiddel0"} style={collapsedStyle} onClick={() => browserHistory.push("/notification_settings")} primaryText={strings.Notification_Settings} />
						</div>,
						<div className="menu-item-wrapper">
							<MenuItem key={"collapsedStyleMiddel1"} style={collapsedStyle} onClick={() => browserHistory.push("/es/timecards")} primaryText={strings.Self_Service} />
						</div>,
						<div className="menu-item-wrapper">
							<MenuItem key={"collapsedStyleLast"} style={collapsedStyleLast} onClick={this.props.onLogoutClick} primaryText={strings.Logout} />
						</div>
					] :
					AccountStore.getScheduleEnabled() ?
						[
							<div className="menu-item-wrapper">
								<MenuItem key={"collapsedStyle"} style={collapsedStyle} onClick={() => browserHistory.push("/notification_settings")} primaryText={strings.Notification_Settings} />
							</div>,
							<div className="menu-item-wrapper">
								<MenuItem key={"collapsedStyleMiddel"} style={collapsedStyle} onClick={() => browserHistory.push("/es/timecards")} primaryText={strings.Self_Service} />
							</div>,
							<div className="menu-item-wrapper">
								<MenuItem key={"collapsedStyleLast"} style={collapsedStyleLast} onClick={this.props.onLogoutClick} primaryText={strings.Logout} />
							</div>
						] :
						[
							<div className="menu-item-wrapper">
								<MenuItem key={"collapsedStyleMiddel"} style={collapsedStyle} onClick={() => browserHistory.push("/es/timecards")} primaryText={strings.Self_Service} />
							</div>,
							<div className="menu-item-wrapper">
								<MenuItem key={"collapsedStyleLast"} style={collapsedStyleLast} onClick={this.props.onLogoutClick} primaryText={strings.Logout} />
							</div>
						]

		if (AccountStore.getEnableWorkflows()) {
			returnVal.splice(returnVal.length - 1, 0, <MenuItem key={returnVal.length + 1} primaryText={strings.Training} onClick={() => browserHistory.push("/workflows")} style={collapsedStyle} />)
		}

		return returnVal
	}

	render() {
		const { cookieAccountId, isAdmin, hierarchySubItems } = this.state
		const loggedInUser = AuthenticationStore.getLoggedInUser()
		if (!loggedInUser) {
			return null
		}
		const active = {
			dashboard: false,
			timecards: false,
			records: false,
			schedule: false,
			employees: false,
			hierarchy: false,
			account: false,
		}

		const path = window.location.pathname

		active.dashboard = /^\/?dashboard/.test(path)
		active.timecards = /^\/?timecards/.test(path)
		active.records = /^\/?records/.test(path)
		active.schedule = /^\/?schedule/.test(path)
		active.employees = /^\/?employees/.test(path) || /^\/?user-details/.test(path)
		active.hierarchy = /^\/?hierarchy/.test(path)
		active.account = /^\/?account/.test(path)

		let submenu = null
		const selectedMenuItem = Object.keys(active).filter((key) => active[key] === true)[0]
		switch (selectedMenuItem) {
			case "schedule":
				submenu = <ScheduleLeftNav filter={this.props.params.filter} />
				break
			case "hierarchy":
				submenu = <HierarchyLeftNav navItems={this.state.hierarchySubItems} selectedItem={this.state.hierarchySelectedItem} />
				break
			case "account":
				let accountNavItems = AppStateStore.accountNavItems
				if (AccountStore.getHideBilling()) {
					accountNavItems = accountNavItems.filter(i => i !== "Billing")
				}
				submenu = <AccountLeftNav accountId={this.state.accountId} navItems={accountNavItems} selectedItem={this.state.accountSelectedItem} />
				break
		}

		if (this.state.expand === "expanded") {
			return (
				<ExpandedLeftNav
					active={active}
					loggedInUser={loggedInUser}
					page={this.props.page}
					submenu={submenu}
					cookieAccountId={cookieAccountId}
					showTimecards={this.state.showTimecards}
					showEquipment={this.state.showEquipment}
					showEmployees={this.state.showEmployees}
					showRecords={this.state.showRecords}
					showTopLeveDevices={this.state.showTopLeveDevices}
					isAdmin={isAdmin}
					defaultHierarchySubItem={hierarchySubItems[0]}
					loggedInUserType={this.props.loggedInUserType}
					showPayroll={this.state.showPayroll}
					showLeaveTracking={this.state.showLeaveTracking}
					showSchedule={this.state.showSchedule}
					showClients={this.state.showClients}
					showJobs={this.state.showJobs}
					showHierarchy={this.state.showHierarchy}
					showGigPool={this.state.showGigPool}
					nestedUserMenuItems={this.getExpandedLeftNavUserNestedItems()}
				/>
			)
		}
		else if (this.state.expand === "collapsed") {
			return (
				<CollapsedLeftNav
					loggedInUser={loggedInUser}
					onProfileClick={this.onProfileClick}
					onLogoutClick={this.props.onLogoutClick}
					cookieAccountId={cookieAccountId}
					showTimecards={this.state.showTimecards}
					showEquipment={this.state.showEquipment}
					showEmployees={this.state.showEmployees}
					showRecords={this.state.showRecords}
					showTopLeveDevices={this.state.showTopLeveDevices}
					isAdmin={isAdmin}
					selectedItem={this.props.selectedItem}
					selectedHierarchy={this.props.selectedHierarchy}
					loggedInUserType={this.props.loggedInUserType}
					showPayroll={this.state.showPayroll}
					showLeaveTracking={this.state.showLeaveTracking}
					showSchedule={this.state.showSchedule}
					showClients={this.state.showClients}
					showJobs={this.state.showJobs}
					showHierarchy={this.state.showHierarchy}
					nestedUserMenuItems={this.getCollapsedLeftNavUserNestedItems()}
				/>
			)
		}
	}
}